import { VeTooltip } from "@packages/ui/components";
import { limiter } from "@packages/ui/hoc";
import { VeBox, VeTypography } from "@packages/ui/mui";

export default function ToolTipBadge({ children, title, disabled }: any) {
  return disabled ? (
    <>{children}</>
  ) : (
    <VeTooltip
      placement="top"
      title={
        <VeBox
          display={"flex"}
          flexDirection={"column"}
          padding={"8px"}
          width={"233px"}
        >
          <VeTypography
            variant="label3Secondary"
            sx={{
              color: "white !important",
              fontSize: "12px",
              textAlign: "center",
            }}
          >
            {title}
          </VeTypography>
        </VeBox>
      }
      arrow
      sx={{ display: "flex" }}
    >
      {children}
    </VeTooltip>
  );
}

export function LimiterToolTip({
  value,
  limit = 30,
  variant = "label2Main",
  className = "",
  cursor = "default",
  width = "233px",
}: any) {
  return value?.length > limit ? (
    <VeTooltip
      placement="top"
      title={
        <VeBox
          display={"flex"}
          flexDirection={"column"}
          padding={"8px"}
          width={width}
        >
          <VeTypography
            variant="label3Secondary"
            sx={{ color: "white !important", fontSize: "12px" }}
            className={className}
          >
            {value}
          </VeTypography>
        </VeBox>
      }
      arrow
      sx={{ display: "flex", cursor: cursor }}
    >
      <VeTypography variant={variant} style={{ cursor: cursor }}>
        {limiter({ strings: value, limit })}
      </VeTypography>
    </VeTooltip>
  ) : (
    <VeTypography
      variant={variant}
      className={className}
      style={{ cursor: cursor }}
    >
      {value}
    </VeTypography>
  );
}
